<template>
  <div style="width: 100%; height: 100%">
    <UserName v-if="!isAuthenticated && !userName" />
    <Project v-else :leaveRoomIfJoined="leaveRoomIfJoined" :activeRoom="activeRoom" :setActiveRoom="setActiveRoom" />
  </div>
</template>

<script>
import UserName from './components/user-name';
import Project from './components/project';

import { AuthMixin } from '../../../../../mixins';

export default {
  name: 'App',
  components: {
    UserName,
    Project,
  },
  mixins: [AuthMixin],
  beforeRouteLeave(to, from, next) {
    this.leaveRoomIfJoined();
    setTimeout(() => {
      window.location.reload(false);
    }, 1000);
    return next();
  },
  data() {
    return {
      activeRoom: null,
      userName: '',
    };
  },
  methods: {
    setActiveRoom(room) {
      this.activeRoom = room;
    },
    setUserName(userName) {
      this.userName = userName;
    },
    leaveRoomIfJoined() {
      if (this.activeRoom) {
        this.activeRoom.disconnect();
        this.activeRoom.localParticipant.videoTracks.forEach((track) => {
          track.track.stop();
        });
        this.activeRoom.localParticipant.audioTracks.forEach((track) => {
          track.track.stop();
        });
      }
    },
  },
};
</script>
